import SectionNavbar from './SectionNavbar';

const mainNav = [
  { route: '/poe2/map', value: '경로석 정규식 검색' },
  { route: '/poe2/tablet', value: '서판 정규식 검색' },
  { route: '/poe2/savelist', value: '정규식 저장 목록' },
];

const utilityNav = [
  { route: '/update', value: '변경사항' },
  { route: '/guide', value: '이용 가이드' },
  { route: '/bugreport', value: '버그 제보' },
];

function Poe2Navbar() {
  return <SectionNavbar mainNav={mainNav} utilityNav={utilityNav} />;
}

export default Poe2Navbar;
